import React from "react"

import StructuredTextWithLink from "../../../dato-components/structured-text-with-link"
import FeatherIcon from "../../../design-system/feather-icon"
import Paragraph from "../../../design-system/paragraph"
import * as styles from "./index.module.scss"
import { useAnnouncementBar } from "./use-announcement-bars"

const AnnouncementBar: React.FC = () => {
  const announcementBar = useAnnouncementBar()
  if (!announcementBar) return null

  const { icon, message } = announcementBar

  return (
    <div className={styles.container}>
      <FeatherIcon type={icon.iconType} size="large" />
      <Paragraph variant="2" textColor="white">
        <StructuredTextWithLink data={message} />
      </Paragraph>
    </div>
  )
}

export default AnnouncementBar
